import {
  Avatar,
  Badge,
  Button,
  Flex,
  notification,
  Spin,
  Upload,
  UploadProps,
} from 'antd'
import ImgCrop from 'antd-img-crop'
import { FaPencil } from 'react-icons/fa6'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { useAppSelector } from '../../utils/redux/store'
import { UploadedFolderDestination } from '../PlaylistFolder/NewFolder'

interface Props {
  onChange?: any //do not pass anything in this prop and don't remove it (antd triggers).
  value?: string
  uploadedDestination: UploadedFolderDestination
}
export function PlaylistPosterFormItem({
  uploadedDestination,
  onChange: updateFormValue,
  value,
}: Props) {
  const isPosterUploading = false
  const { token } = useAppSelector((state) => state.auth)

  const uploadProps: UploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    accept: 'image/jpeg, image/png, image/jpg',
    action: `${process.env.REACT_APP_API_BASE_URL}/${uploadedDestination}/upload`,
    onChange: (info) => {
      if (info.file.status === 'uploading') {
      } else if (info.file.status === 'done') {
        updateFormValue(info.file.response)
      } else if (info.file.status === 'error') {
        if (info.file.response.statusCode === 401)
          notification.error({
            message: `Your session has expired, please re login and try again`,
          })
        else
          notification.error({
            message: `Could not upload ${info.file.name} file at this moment`,
          })
      }
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  return (
    <Flex justify="center" align="center" style={{ marginBottom: '3em' }}>
      <Badge
        count={
          <div>
            <ImgCrop rotationSlider showGrid cropShape="rect">
              <Upload {...uploadProps}>
                <Button shape="circle">
                  <FaPencil />
                </Button>
              </Upload>
            </ImgCrop>
          </div>
        }
        offset={[0, 150]}
      >
        <Avatar
          size={150}
          onClick={() => {
            console.log(`${process.env.REACT_APP_UPLOADED_BASE_URL + '/' + uploadedDestination}/${value}`)
          }}
          shape="square"
          icon={<HiMiniNoSymbol />}
          src={isPosterUploading ? <Spin /> : `${process.env.REACT_APP_UPLOADED_BASE_URL + '/' + uploadedDestination}/${value}`}
        />
      </Badge>
    </Flex>
  )
}
